import { Typography } from '@mui/material';

export const Title = ({ title }: { title: string }) => {
  return (
    <Typography
      variant="h1"
      sx={{ fontWeight: 700, fontSize: '1.25rem' }}
      data-testid="page-title"
    >
      {title}
    </Typography>
  );
};
